import { render, staticRenderFns } from "./DesignTable.vue?vue&type=template&id=433da58c&scoped=true&"
import script from "./DesignTable.vue?vue&type=script&lang=js&"
export * from "./DesignTable.vue?vue&type=script&lang=js&"
import style0 from "./DesignTable.vue?vue&type=style&index=0&id=433da58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433da58c",
  null
  
)

export default component.exports